import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "step-balloon" }
const _hoisted_2 = { class: "count" }
const _hoisted_3 = {
  key: 0,
  class: "triangle-gray"
}
const _hoisted_4 = {
  key: 1,
  class: "triangle"
}
const _hoisted_5 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["title-balloon", { 'no-border': !_ctx.isBorder }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["balloon", { gray: _ctx.isColorGray }])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "step" }, "step", -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.count), 1),
        (_ctx.isColorGray)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4)),
        (_ctx.isBorder)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["border", { 'blue-border': _ctx.isBlueBorder }])
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("p", {
        class: _normalizeClass(["title", { gray: _ctx.isColorGray }]),
        textContent: _toDisplayString(_ctx.title)
      }, null, 10, _hoisted_5)
    ], 2)
  ]))
}